import React from "react";
import { ColorGradient } from "@progress/kendo-react-inputs";
import { Sortable } from '@progress/kendo-react-sortable';
import {
    SpheraInput, SpheraTextAreaFields, SpheraDropdownEx, SpheraButtonEx, SpheraTooltip, SpheraCheckbox
} from "@sphera-cloud/component-ui-reactjs";
import { SortableMaterialColumn } from './SortableMaterialColumn';
import { SortableCustomerProperty } from './SortableCustomerProperty';
import { FileUpload } from './FileUpload';
import { htmlDecode } from "../services/Utils";

export function PublicSiteForm(props) {
    const toggleCustomColumn = () => { };
    const onDragOver = event => { props.setmaterialColumns(event.newState); };
    const onNavigate = event => { props.setmaterialColumns(event.newState); };
    const docOnDragOver = event => { props.setdocumentColumns(event.newState); };
    const docOnNavigate = event => { props.setdocumentColumns(event.newState); };

    const changeToken = event => {
        let site = props.selectedSite;
        site.apiToken = event.value;
        props.setselectedSite(site);
    }
    const changeName = event => {
        let site = props.selectedSite;
        site.name = event.value;
        props.setselectedSite(site);
    }
    const changeDescription = event => {
        let site = props.selectedSite;
        site.description = event.value;
        props.setselectedSite(site);
    }
    const changePath = event => {
        let site = props.selectedSite;
        site.url = event.value;
        props.setselectedSite(site);
    }
    const changepasswordProtected = event => {
        let site = props.selectedSite;
        site.passwordProtected = event.value;
        props.setselectedSite(site);
    }

    const changeSecondaryHeader = event => {
        props.setselectedSite({ ...props.selectedSite, secondaryHeaderColumnId: event.value.columnId });
    }
    const changeTertiaryHeader = event => {
        props.setselectedSite({ ...props.selectedSite, tertiaryHeaderColumnId: event.value.columnId });
    }

    // Material Header field configuration (primary is always materialName). The header mirrors the
    // main app: fields are selectable from ALL material columns, independent of which columns are
    // exposed (Selected) on the portal grid -- so a header may reference a column that isn't shown
    // in the portal's column list. Titles come from the customer's material columns (alias-resolved).
    const noneOption = { columnId: null, label: props.localizations.None ?? "None" };
    const headerColumnOptions = (props.allMaterialColumns || [])
        .filter(c => c.field !== "materialName")
        .map(c => ({ columnId: c.columnId, label: c.Title }));
    const primaryHeaderLabel = (props.allMaterialColumns || []).find(c => c.field === "materialName")?.Title ?? "";
    const secondaryOptions = [noneOption, ...headerColumnOptions.filter(o => o.columnId !== props.selectedSite.tertiaryHeaderColumnId)];
    const tertiaryOptions = [noneOption, ...headerColumnOptions.filter(o => o.columnId !== props.selectedSite.secondaryHeaderColumnId)];

    const pathFieldValidator = (value) => {
        if (!value || value?.length === 0)
            return props.localizations.FieldRequired;
        let pattern = /\s/g;
        let result = value.match(pattern);

        if (result && result.length > 0)
            return props.localizations.NoSpacesError;
    };

    return (
        <div>
            <div className="row mb-3">
                <div className="col-3">
                    <SpheraTooltip position="top">
                        <SpheraInput
                            title={props.localizations.SiteName}
                            label={props.localizations.SiteName}
                            name="name"
                            required
                            type="text"
                            placeholder={props.localizations.SiteName}
                            maxLength={30}
                            value={htmlDecode(props.selectedSite.name)}
                            onChange={changeName}
                        />
                    </SpheraTooltip>
                </div>
                <div className="col-3">
                    <SpheraTooltip position="top">
                        <SpheraInput
                            title={props.localizations.PublishedUrl + `: ${props.baseDomain}/{your path}`}
                            label={props.localizations.Path}
                            name="url"
                            required
                            type="text"
                            placeholder={props.localizations.Path}
                            value={htmlDecode(props.selectedSite.url)}
                            onChange={changePath}
                            validator={pathFieldValidator}
                        />
                    </SpheraTooltip>
                    {props.isDuplicate ? <div className="searchNotValidText">{props.localizations.SiteNameValidation}</div> : ""}
                </div>
                <div className="col-3">
                    <SpheraTooltip position="top">
                        <SpheraDropdownEx
                            title={props.localizations.Token}
                            name="token"
                            required
                            label={props.localizations.Token}
                            options={props.apiTokens}
                            type="combo-box"
                            width="29rem"
                            filterable
                            value={props.apiTokens.find(x => props.selectedSite.apiToken != null && x.value == props.selectedSite.apiToken.id)}
                            onChange={changeToken}
                        />
                    </SpheraTooltip>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-6">
                    <SpheraTooltip position="top">
                        <SpheraTextAreaFields
                            title={props.localizations.Description}
                            label={props.localizations.Description}
                            name="name"
                            type="text"
                            placeholder={props.localizations.Description}
                            maxLength={255}
                            value={props.selectedSite.description}
                            onChange={changeDescription}
                        />
                    </SpheraTooltip>
                </div>
                <div className="col-6">
                    <div className="row mb-3">
                        <SpheraDropdownEx wrap filterable label={props.localizations.Filters} onChange={props.handleFilterDropdownChange} options={props.filtersDropdownData} width="100%" value={props.filterSelected} />    
                    </div>
                    <SpheraCheckbox label={props.localizations.PasswordProtected} primary={true} value={props.selectedSite.passwordProtected == 1 ? true : false} onChange={changepasswordProtected} />
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <SpheraDropdownEx wrap filterable label={props.localizations.DefaultText} onChange={props.handleDefaultTextDropdownChange} options={props.defaultTextDropdownData} width="100%" value={props.defaultTextSelected} />   
                </div>
            </div>

            <br />
            <div className="row">
                <div className="col-4">
                    <label className="sphera-label-text">{props.localizations.HeaderColor}</label>
                </div>
                <div className="col-8">
                    <label className="sphera-label-text">Icon</label>
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <ColorGradient
                        value={props.colorValue}
                        onChange={props.handlecolorValueChange}
                        style={{
                            marginTop: "10px",
                            width: "242px"
                        }}
                    />
                </div>
                <div className="col-1">
                    <div style={{ background: props.colorValue, width: "60px", height: "60px", marginTop: "27px" }} > </div>
                </div>
                <FileUpload changeHandler={props.changeHandler} localizations={props.localizations} uploadedFile={props.uploadedFile} logoUrl={props.logoUrl} removeLogo={props.removeLogo} />
            </div>
            <br />
            <div className="row mb-3">
                <label className="sphera-label-text" style={{ marginTop: "10px" }} >{props.localizations.MaterialHeader}</label>
                <div className="row">
                    <div className="col-4">
                        <span><b>{props.localizations.PrimaryField}</b></span>
                        <div><span>{primaryHeaderLabel}</span></div>
                    </div>
                    <div className="col-4">
                        <span><b>{props.localizations.SecondaryField}</b></span>
                        <SpheraDropdownEx
                            options={secondaryOptions}
                            value={secondaryOptions.find(o => o.columnId === (props.selectedSite.secondaryHeaderColumnId ?? null))}
                            textField="label"
                            dataItemKey="columnId"
                            onChange={changeSecondaryHeader}
                            width="100%"
                        />
                    </div>
                    <div className="col-4">
                        <span><b>{props.localizations.TertiaryField}</b></span>
                        <SpheraDropdownEx
                            options={tertiaryOptions}
                            value={tertiaryOptions.find(o => o.columnId === (props.selectedSite.tertiaryHeaderColumnId ?? null))}
                            textField="label"
                            dataItemKey="columnId"
                            onChange={changeTertiaryHeader}
                            width="100%"
                        />
                    </div>
                </div>
            </div>
            <div className="row mb-3">
                <label className="sphera-label-text" style={{ marginTop: "10px" }} >{props.localizations.MaterialColumns}</label>
                <div className="row">
                    <div className="col-5">
                        <span className="ColumnsNameHeaderPs"><b>{props.localizations.Column}</b></span>
                    </div>
                    <div className="col-4">
                        <span className="ColumnsPrivateHeader"><b>{props.localizations.Include}</b></span>
                    </div>
                    <div className="col-3">
                        <SpheraButtonEx
                            text={props.localizations.SetColumnWidths}
                            className="SetWidthsBtn btn"
                            onClick={() => props.toggleWidthsModal(true)}
                        />
                    </div>
                </div>
                <div className="sortable">
                    <Sortable idField={'customerColumnId'} data={props.materialColumns} itemUI=
                        {(props2) => (
                            <SortableMaterialColumn {...props2} localizations={props.localizations} includecustomcolumn1Change={props.includecustomcolumn1Change}
                                toggleCustomColumn={toggleCustomColumn} isSettings={false} />
                        )}
                        onDragOver={onDragOver} onNavigate={onNavigate} />
                </div>
                <label className="sphera-label-text" style={{ marginTop: "10px" }} >{props.localizations.DocumentColumns}</label>
                <div className="row">
                    <div className="col-5">
                        <span className="ColumnsNameHeaderPs"><b>{props.localizations.Column}</b></span>
                    </div>
                    <div className="col-4">
                        <span className="ColumnsPrivateHeader"><b>{props.localizations.Include}</b></span>
                    </div>
                    <div className="col-3">
                        <SpheraButtonEx
                            text={props.localizations.SetColumnWidths}
                            className="SetWidthsBtn btn"
                            onClick={() => props.toggleWidthsModal(false)}
                        />
                    </div>
                </div>
                <div className="sortable">
                    <Sortable idField={'customerColumnId'} data={props.documentColumns} itemUI=
                        {(props2) => (
                            <SortableMaterialColumn {...props2} localizations={props.localizations} includecustomcolumn1Change={props.includecustomcolumn1Change}
                                toggleCustomColumn={toggleCustomColumn} isSettings={false} />
                        )}
                        onDragOver={docOnDragOver} onNavigate={docOnNavigate} />
                </div>
                <label className="sphera-label-text" style={{ marginTop: "10px" }} >{props.localizations.PropertyDisplaySettings}</label>
                <div className="row">
                    <div className="col-5" style={{ fontSize: "12px" }} >
                        <span><b>{props.localizations.Section}</b></span>
                    </div>
                    <div className="col-2" style={{ fontSize: "12px" }}>
                        <span><b>{props.localizations.Include}</b></span>
                    </div>
                </div>
                <div className="sortable">
                    <Sortable idField={'phraseSectionId'} data={props.PhraseSectionCustomer}
                        itemUI={(props2) => (
                            <SortableCustomerProperty {...props2} localizations={props.localizations} propscheckChange={props.propscheckChange} />
                        )}
                        onDragOver={props.propOnDragOver} onNavigate={props.propOnNavigate} />
                </div>
            </div>
        </div>
    );
}